<template>
  <CodesHistoryPanel
    :doorphone-id="$route.params.id"
    :include-doorphone-address="false"
    temp-route="DetailDoorphoneTempCodeProvisionHistory"
    service-route="DetailDoorphoneServiceDoorCodeHistory"
  />
</template>

<script>
import CodesHistoryPanel from './CodesHistoryPanel.vue';

export default {
  name: 'CodesHistoryDoorphoneTab',
  components: { CodesHistoryPanel },
};
</script>
